module.exports = __webpack_public_path__ + "img/electronic_reserved_selected.76e1a9d2.svg";